import _ from "underscore";
import * as aj from "../aj/index";
import { STORES } from "./types";
import { completed, failed } from "../utils/ajex";
import { SET_STORE_TARGET, LOAD_TARGET_QUESTIONS_TREE, LOAD_STORE_TARGETS, UPDATE_STORE_TARGETS, LOAD_ALLOWED_STORES, GET_STORES_STATS  } from "../actions/types";
import { flatNodes } from "../model/nodes";
import { updatedList } from "../utils/lang";


export function getDefaultState() {
    return {
        questionNodes: null,
        targets: [],
        storesStats: [],
    }
}

function toInputValues(targets) {
    const inputValues = {};

    targets.forEach(w => {
        inputValues[w.questionTemplateId] = w.value;
    })

    return inputValues;
}

function toQuestionNodes(questionsTree) {
    const roots = [];

    questionsTree.roots?.forEach(macroarea => {
        macroarea.children?.forEach(area => {
            const areaNode = {
                id: area.id,
                description: area.category.description,
                type: "area",
                children: []
            }

            area.children?.forEach(category => {               
                const categoryNode = {
                    id: category.id,
                    description: category.category.description,
                    type: "category",
                    children: []
                }
                
                category.questions.forEach(question => {
                    const questionNode = {
                        id: question.question.template.id,
                        description: question.question.template.description,
                        type: "question",
                    }

                    categoryNode.children.push(questionNode);
                })

                areaNode.children.push(categoryNode);                
            })

            roots.push(areaNode);
        })
    })

    return roots;
}

export const StoresStore = aj.createStore(STORES, (state = getDefaultState(), action) => {

    switch(action.type) {
        case completed(LOAD_TARGET_QUESTIONS_TREE):
            return _.assign(state, {questionNodes: toQuestionNodes(action.questionsTree)});

        case completed(LOAD_STORE_TARGETS):
            return _.assign(state, {
                targets: action.targets,
                inputValues: toInputValues(action.targets ?? [])
            });

        case SET_STORE_TARGET:
            const newInput = {};
            newInput[action.questionTemplateId] = action.value;
            return _.assign(state, {
                targets: updatedList(
                    state.targets ?? [], 
                    (w) => w.questionTemplateId == action.questionTemplateId,
                    (w) => _.assign({}, w, {questionTemplateId: action.questionTemplateId, value: action.value}),
                    true
                ),
                inputValues: _.assign(state.inputValues, newInput)
            })

        case completed(LOAD_ALLOWED_STORES):
            return _.assign(state, {
                allowedStores: action.allowedStores
            });

        case completed(GET_STORES_STATS):
            return _.assign(state, {
                storesStats: action.storesStats,
            });
       
    }

})